import React from "react";
import Button from "../button";
import BaseModal from "../modal/base/BaseModal";

type DialogProps = {
  close: () => void;
  title?: string;
  subTitle?: string;
  content?: string;
  children?: React.ReactNode;
  onConfirm?: () => void;
};

const AlertDialog = (props: DialogProps) => {
  const { close, title, subTitle, content, children, onConfirm } = props;

  return (
    <BaseModal className="p-[20px]" size="dialog" close={close}>
      <section className="flex flex-col min-h-[154px] space-y-4 justify-between ">
        <div className="w-full text-center flex-1 flex flex-col items-center space-y-2">
          <div className="">
            <p className="text-base font-bold whitespace-pre-line break-keep">
              {title}
            </p>
            <p className="tex-sm font-bold">{subTitle}</p>
          </div>
          <div className="flex-1 flex items-center">
            {children && children}
            {!children && content && (
              <p className="text-[#888] text-xs font-[500] whitespace-pre-line break-keep">
                {content}
              </p>
            )}
          </div>
        </div>

        <Button
          label="확인"
          variant={"black"}
          onClick={() => {
            close();
            onConfirm?.();
          }}
        />
      </section>
    </BaseModal>
  );
};

export default React.memo(AlertDialog);
